import React from "react";
import { Box, Divider, Typography } from "@material-ui/core";
import { LocationImageCard } from "../LocationImageCard";
import { LocationVideoCard } from "../LocationVideoCard";

// styles
import useStyles from "./styles";

function SectionLocationGalleryList({ sectionList }) {
  const styles = useStyles();

  return (
    <>
      {sectionList.map((section, index) => (
        <Box key={index} className={styles.containerImageSection}>
          <Box className={styles.containerImageTitle}>
            {section?.icon}
            <Typography className={styles.ImageVedioTitle}>
              {section?.title}
            </Typography>
            <Divider
              style={{ flexGrow: 1, alignSelf: "center", marginLeft: 12 }}
            />
          </Box>
          
          {section?.type === "images" &&
            Array.isArray(section?.data) &&
            section.data.length > 0 && (
              <Box className={styles.containerImageCards}>
                {section.data.map((item, idx) => (
                  <LocationImageCard key={idx} data={item} />
                ))}
              </Box>
            )}

          {section?.type === "videos" &&
            Array.isArray(section?.data) &&
            section.data.length > 0 && (
              <Box className={styles.containerImageCards}>
                {section.data.map((item, idx) => (
                  <LocationVideoCard key={idx} data={item} />
                ))}
              </Box>
            )}
        </Box>
      ))}
    </>
  );
}

export default SectionLocationGalleryList;
